import { twMerge } from 'tailwind-merge';

import { Skeleton } from '@/_components';

import type { LoaderProps } from './types';

export function LoaderInline({ withLabel, className }: LoaderProps) {
  return (
    <article className={twMerge('-mt-5 flex flex-col gap-1', className)}>
      {withLabel && <Skeleton className="h-2 w-32" />}
      <div className="bg-background-paper overflow-hidden rounded-xl">
        <section className="flex flex-col gap-4 pt-4 pr-2 pb-2 pl-0">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-4/5" />
        </section>
      </div>
    </article>
  );
}
